import React from 'react';
import { FileWarning, AlertTriangle } from 'lucide-react';
export function CasesSection() {
  const cases = [{
    id: 1,
    title: 'CASO NISMEN: EL SILENCIO DEL PODER',
    desc: 'Un fiscal hallado muerto justo antes de una denuncia explosiva. ¿Suicidio por presión o un asesinato planeado desde las sombras? Analiza los registros de acceso al edificio y las llamadas al 911. El poder quiere que este caso se quede cerrado. ¿Lo permitirás?',
    tags: 'Corrupción · Poder · Conspiración',
    difficulty: 'ALTA'
  }, {
    id: 2,
    title: 'RELACIONES TÓXICAS: EL CASO CARMEN GARCÍA',
    desc: 'Carmen desapareció tras una noche de copas. En su expediente encontrarás chats de WhatsApp, publicaciones en redes sociales y testimonios cruzados. En un mundo de apariencias digitales, el asesino dejó un rastro de bits que solo una mente afilada puede seguir.',
    tags: 'Obsesión Digital · Desaparición · Redes Sociales',
    difficulty: 'MEDIA'
  }, {
    id: 3,
    title: 'STEVE JACOBS: EL ESCÁNDALO CORPORATIVO',
    desc: 'El CEO de una gran aseguradora muere en la bañera de un hotel de lujo. Todo parece un infarto, hasta que revisas el informe del laboratorio forense. Hay una pieza de ajedrez en la escena que no debería estar ahí. ¿Quién se beneficia de su muerte?',
    tags: 'Fraude Corporativo · Veneno · Hotel de Lujo',
    difficulty: 'ALTA'
  }, {
    id: 4,
    title: 'LINDA OWARD: EL ASESINO DEL GIRASOL',
    desc: 'Un caso ritualista que te helará la sangre. Un asesino serial que deja una firma floral en cada víctima. Recibirás fotos de la escena, grabaciones de llamadas anónimas y un perfil psicológico del FBI. Solo el 5% de los jugadores logra atrapar a este asesino a la primera.',
    tags: 'Asesino Serial · Ritual · Perfil FBI',
    difficulty: 'EXTREMA',
    warning: true
  }];
  return <section className="py-10 md:py-16 px-4 bg-[#151515]" data-id="element-10">
      <div className="max-w-6xl mx-auto" data-id="element-11">
        <div className="text-center mb-8" data-id="element-12">
          <h2 className="text-3xl md:text-5xl font-bold text-[#e5e5e5] font-['Special_Elite'] uppercase tracking-widest" data-id="element-13">
            4 Casos. 4 Asesinos. <br data-id="element-14" />
            <span className="text-[#cc2200]" data-id="element-15">1 Solo Detective: Tú.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-16">
          {cases.map(c => <div key={c.id} className="relative bg-[#c8b89a] p-1 rounded-sm shadow-2xl transform hover:-translate-y-1 transition-transform duration-300" data-id="element-17">
              {/* Folder Tab */}
              <div className="absolute -top-6 left-0 w-1/3 h-8 bg-[#b8a88a] rounded-t-lg border-t border-l border-r border-[#98886a]" data-id="element-18"></div>

              {/* Folder Content */}
              <div className="bg-[#dcd0b9] h-full p-6 md:p-8 rounded-sm border border-[#b8a88a] relative overflow-hidden" data-id="element-19">
                {/* Stamp */}
                <div className="absolute top-4 right-4 opacity-80 transform rotate-12 border-4 border-[#cc2200] text-[#cc2200] px-2 py-1 font-['Special_Elite'] font-bold text-xl uppercase tracking-widest mask-image-grunge" data-id="element-20">
                  CONFIDENCIAL
                </div>

                {/* Case Number */}
                <div className="inline-block bg-[#2a2a2a] text-white font-mono text-xs px-2 py-1 mb-4" data-id="element-21">
                  EXPEDIENTE #{c.id}00{c.id}
                </div>

                <h3 className="text-2xl font-bold text-[#0a0a0a] font-['Special_Elite'] mb-4 uppercase leading-tight" data-id="element-22">
                  {c.title}
                </h3>

                <p className="text-[#2a2a2a] font-mono text-sm md:text-base leading-relaxed mb-6 border-l-2 border-[#cc2200] pl-4" data-id="element-23">
                  {c.desc}
                </p>

                <div className="flex flex-wrap items-center gap-2 mt-auto" data-id="element-24">
                  <span className="text-xs font-bold text-[#555] uppercase tracking-wider" data-id="element-25">
                    {c.tags}
                  </span>
                </div>

                {c.warning && <div className="mt-4 flex items-center gap-2 text-[#cc2200] font-bold text-sm uppercase animate-pulse" data-id="element-26">
                    <AlertTriangle className="w-4 h-4" data-id="element-27" />
                    DIFICULTAD EXTREMA
                  </div>}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}